import AxiosClient from "../AxiosClient";

export const getContainerShippingSummary = (params) => {
  const url = "/api/container/searchSummaryInfoList";
  return AxiosClient.post(url, params);
};

export const getContainerShipping = (params) => {
  const url = "/api/container/searchInfoList";
  return AxiosClient.post(url, params);
};

export const addContainerShipping = (params) => {
  const url = "/api/container/insertInfo";
  return AxiosClient.post(url, params);
};
